// extracted by mini-css-extract-plugin
export var checkbox = "_2t-0";
export var circle = "_2t-3";
export var horizontalContainer = "_2t-7";
export var sm = "_2t-5";
export var switch0 = "_2t-2";
export var switchDisabled = "_2t-8";
export var switchEnabled = "_2t-1";
export var textSwitchContainer = "_2t-9";
export var textSwitchOption = "_2t-a";
export var textSwitchOptionSelected = "_2t-b";
export var verticalContainer = "_2t-6";
export var xs = "_2t-4";